import { CheckCircle, Gift, Info } from 'lucide-react';
import type { UserInfo } from '@/types';
import { formatTokenAmount } from '@/utils/common';

interface WithdrawalManagerProps {
  userInfo: UserInfo;
}

export function WithdrawalManager({ userInfo }: WithdrawalManagerProps) {
  const immediateAmount = userInfo.unlocked; // 30% 立即获得的金额

  return (
    <div className="space-y-6 w-full">
      {/* 立即提取完成状态 */}
      <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-lg p-6">
        <div className="flex items-center space-x-3 mb-4">
          <CheckCircle className="h-8 w-8 text-green-600" />
          <div>
            <h3 className="text-lg font-semibold text-green-800">Immediate Withdrawal Completed</h3>
            <p className="text-sm text-green-600">Your rewards have been successfully processed</p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 mt-4">
          <div className="bg-white/70 p-4 rounded-lg border border-green-100">
            <div className="flex items-center space-x-2 mb-2">
              <Gift className="h-5 w-5 text-green-600" />
              <p className="text-sm font-medium text-green-800">Received Immediately</p>
            </div>
            <p className="text-2xl font-bold text-green-700">{formatTokenAmount(immediateAmount)} TAC</p>
            <p className="text-xs text-green-600 mt-1">30% of total rewards</p>
          </div>
        </div>
      </div>

      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
        <div className="flex items-start space-x-3">
          <Info className="size-6 text-amber-600 mt-0.5" />
          <div className="text-sm text-amber-800">
            <p className="font-medium mb-2">About Immediate Withdrawal</p>
            <ul className="space-y-1 text-xs">
              <li>• You chose the immediate withdrawal option and received 30% of your total rewards instantly</li>
              <li>• The remaining 70% has been allocated to support protocol development and ecosystem growth</li>
              <li>• This transaction is final and cannot be reversed</li>
              <li>• Your rewards have been sent directly to your TON wallet</li>
            </ul>
          </div>
        </div>
      </div>

      {/* 操作完成提示 */}
      <div className="text-center py-4">
        <div className="inline-flex items-center space-x-2 text-slime-600">
          <CheckCircle className="h-5 w-5" />
          <span className="text-sm font-medium">All operations completed successfully</span>
        </div>
        <p className="text-xs text-gray-500 mt-1">
          You can safely close this page. Check your TON wallet for the received tokens.
        </p>
      </div>
    </div>
  );
}
